import React, { useState } from 'react';

const ExpandableText = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const truncatedText = text.length > 100 ? `${text.slice(0, 100)}...` : text;

  return (
    <div className='divdelosdivs'>
      <div className="text-wrapper" style={{ maxHeight: isExpanded ? 'none' : '7rem', overflow: 'hidden' }}>
        {isExpanded ? text : truncatedText}
      </div>
      {text.length > 100 && (
        <button
          className="expand-btn"
          onClick={toggleExpand}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: 'blue',
            cursor: 'pointer',
            marginTop: '5px',
          }}
        >
          {isExpanded ? '-' : '+'}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
